export const GET_EVENT_TYPES = "GET_EVENT_TYPES";
export const GET_EVENT_TYPE_BY_ID = "GET_EVENT_TYPE_BY_ID";
export const UPDATE_EVENT_TYPE = "UPDATE_EVENT_TYPE";
export const DELETE_EVENT_TYPE = "DELETE_EVENT_TYPE";
export const CREATE_EVENT_TYPE = "CREATE_EVENT_TYPE";
export const GET_EVENT_TYPE_COACHES = "GET_EVENT_TYPE_COACHES";
